import React, { useMemo } from 'react';
import { Box, Text } from '@common-fe/common-fe';

import { ROUTES } from '@/common';
import Link from '@/modules/core/components/Link';

import { PlanDetailRow } from './components';
import { PlanDetailRowData } from './EmployerPlanDetails.types';

interface Props {
  planId?: string;
  data?: PlanDetailRowData[];
}
const EmployerPlanDetails: React.FC<Props> = ({ planId, data = [] }) => {
  const [firstColumn, secondColumn] = useMemo(() => {
    const even = data.filter((_, index) => index % 2 === 0);
    const odd = data.filter((_, index) => index % 2 === 1);
    return [even, odd];
  }, [data]);
  return (
    <Box
      pad={{
        vertical: 'spacing24',
        horizontal: 'spacing16',
      }}
      background="canvas"
      round="container2Round"
      border={{ size: '1px', color: 'border2' }}
      direction="column"
      data-testid="employer-plan-details"
    >
      <Box direction="row" justify="between" align="start">
        <Text data-testid="employer-plan-details_title" weight={700}>
          Plan details & deadlines
        </Text>
        {!!planId && (
          <Link testId="employer-plan-details_view-plan-link" to={ROUTES.PLAN_BY_ID(planId)} isOpenNewTab>
            <Text weight={400} color="textAccent">
              View Plan
            </Text>
          </Link>
        )}
      </Box>
      <Box direction="row" margin={{ top: 'spacing8' }} gap="spacing24">
        {firstColumn && firstColumn.length && (
          <Box direction="column" gap="spacing16" fill>
            {firstColumn.map((row) => (
              <PlanDetailRow key={row.key} label={row.label} value={row.value} indicator={row.indicator} />
            ))}
          </Box>
        )}
        <Box width="2px" background="module" />
        {secondColumn && secondColumn.length && (
          <Box direction="column" gap="spacing16" fill>
            {secondColumn.map((row) => (
              <PlanDetailRow key={row.key} label={row.label} value={row.value} indicator={row.indicator} />
            ))}
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default EmployerPlanDetails;
